const summary_keys = ['total', 'count', 'average', 'high', 'low']


export const detectDataType = (data?: Record<string, unknown>[]): string => {
  
  let type = 'unknown'
  let count = 0
  if (!data || !data?.length) return type
  if (data?.[0]) { 
    Object.keys(data?.[0] || {}).forEach((k) => {
      if (summary_keys.includes(k)) count += 1
    })
    if (count >= 3) type = 'summary'
  }
  return type
}